import CloseIcon from '@mui/icons-material/Close';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import React, { useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import TimezoneData from '../../../assets/data/TimezoneData';
import { ControlpanelPrimaryButton, ControlpanelSecondaryButton, GrayIconButton } from '../../../components/StyledButton';
import { CustomDialog } from '../../../components/StyledComponents';
import CustomDateTimePicker from '../../../components/CustomDateTimeRangePicker';
import CustomInput from './../../../components/CustomInput';
import CustomSelect from './../../../components/CustomSelect';
import { toast } from 'react-toastify';
import { format } from 'date-fns';
import { editRequest } from '../../../axios/Eventlog/EventLogApi';
import { useAuth } from '../../../context/AuthContext';
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { getShiftByUser } from '../../../axios/Shift/ShiftApi';

dayjs.extend(utc);
dayjs.extend(timezone);

const EditRequestDialogByUser = ({ onClose, usersData, shiftsData, onRefresh, info, tabName, parsedNewData, parsedOldData }) => {
   const { t } = useTranslation();
   const { profile, dateTimeFormat } = useAuth();
   const MAX_DESCRIPTION_LENGTH = 255;
   // const [timeRequest, setTimeRequest] = useState("");
   // const [dateRequest, setDateRequest] = useState("")
   const [shiftsData1, setShiftsData] = useState([]);
   const [loadingCount, setLoadingCount] = useState(0);
   const [isSubmitting, setIsSubmitting] = useState(false);
   const isDialogLoading = loadingCount > 0 || isSubmitting;

   const handleCloseDialog = () => {
      onClose();
   };

   const normalizeTime = (time) => {
      if (!time) return null;

      if (/^\d{2}:\d{2}$/.test(time)) {
         return `${time}:00`;
      }

      if (/^\d{2}:\d{2}:\d{2}$/.test(time)) {
         return time;
      }

      return time;
   };

   const toDateTimeValue = (date, time) => {
      if (!date) return null;
      if (!time) return date;

      return dayjs(
         `${dayjs(date).format('YYYY-MM-DD')} ${normalizeTime(time) || time}`
      ).toDate();
   };


   const handleInputChange = (e) => {
      const { name } = e.target;
      let { value } = e.target;

      if (name === 'description') {
         value = value.slice(0, MAX_DESCRIPTION_LENGTH);
      }

      setFormData((prevData) => ({
         ...prevData,
         [name]: value,
      }));
   };


   // const shift = shiftsData.find((item) => item.shiftId === parsedNewData.shiftId);
   // const isEditEvent = info?.requestTypeName === 'EDIT_EVENT_LOG';
   // let time = '';

   // if (info?.requestTypeName === 'EDIT_EVENT_LOG') {
   //    time = parsedNewData?.time || '';
   // } else {
   //    const isCheckIn = parsedNewData?.eventTypeId === 1;
   //    const fullTime = isCheckIn ? parsedNewData?.timeCheckIn : parsedNewData?.timeCheckOut;
   //    time = fullTime?.split(' ')[1] || '';
   // }
   const shift = shiftsData.find((item) => item.shiftId === parsedNewData.shiftId);
   const isEditEvent = !!parsedNewData?.attendanceDateTime;
   let dateValue = null;
   const splitDateTimeFromGMT = (timeGMT, timeZone) => {
      if (!timeGMT || !timeZone) {
         return { eventDate: "", eventTime: "" };
      }

      const sign = timeZone.startsWith("-") ? -1 : 1;
      const [hh, mm] = timeZone.slice(1).split(":").map(Number);
      const offsetMinutes = sign * (hh * 60 + mm);

      const local = dayjs
         .utc(timeGMT)
         .add(offsetMinutes, "minute");

      return {
         eventDate: local.format("YYYY-MM-DD"),
         eventTime: local.format("HH:mm:ss"),
      };
   };

   const browserTZ = dayjs.tz.guess();

   const parseBusinessDateTime = (parsedNewData) => {
      // CASE: ADD_EVENT_LOG
      if (parsedNewData?.timeCheckIn) {
         const [date, time] = parsedNewData.timeCheckIn.split(' ');
         return {
            date: new Date(date),
            time
         };
      }

      // ✅ CASE: attendanceDateTime UTC
      if (parsedNewData?.attendanceDateTime) {
         const local = dayjs
            .utc(parsedNewData.attendanceDateTime)
            .tz(browserTZ);

         return {
            date: local.toDate(),
            time: local.format("HH:mm:ss"),
         };
      }

      return { date: null, time: "00:00:00" };
   };


   const { date, time } = parseBusinessDateTime(parsedNewData);

   const parseOldAttendanceDateTime = (oldData) => {
      if (!oldData?.attendanceDateTime) {
         return { date: null, time: '' };
      }

      const local = dayjs(oldData.attendanceDateTime); // ❗ KHÔNG utc(), KHÔNG add()

      return {
         date: local.toDate(),
         time: local.format('HH:mm:ss'),
      };
   };


   const parsedOldDataObj = useMemo(() => {
      try {
         return info?.oldData ? JSON.parse(info.oldData) : null;
      } catch {
         return null;
      }
   }, [info?.oldData]);

   const { date: oldDate, time: oldTime } = parseOldAttendanceDateTime(parsedOldDataObj);

   const locationOld = parsedOldDataObj?.location || '';
   const locationNew = parsedNewData?.location || info?.location || '';

   const oldEventTypeId = parsedOldDataObj?.eventTypeId;

   const shiftOldName = useMemo(() => {
      if (!parsedOldDataObj?.shiftId || parsedOldDataObj.shiftId === 0) {
         return t('common.default');
      }

      const oldShift = shiftsData.find(
         (s) => s.shiftId === parsedOldDataObj.shiftId
      );

      if (!oldShift) return t('common.default');

      // ⚠️ nếu backend trả "DEFAULT" → ép dịch
      if (oldShift.shiftName === 'DEFAULT') {
         return t('common.default');
      }

      return oldShift.shiftName || oldShift.name;
   }, [parsedOldDataObj?.shiftId, shiftsData, t]);

   const initialFormData = {
      eventType: parsedNewData?.eventTypeId ? parsedNewData.eventTypeId : 0,
      username: profile.fullName,
      selectDate: date,
      selectTime: time,
      selectDateOld: oldDate,
      selectTimeOld: oldTime,
      timeZone: parsedNewData?.timeZone ? parsedNewData.timeZone : '',
      timeZoneOld: parsedOldData?.timeZone ? parsedOldData.timeZone : '',
      shift: shift ? shift.shiftId : '',
      shiftOld: shiftsData.find(s => s.shiftId === parsedOldDataObj?.shiftId)?.shiftName || '',

      descriptionOld: '',
      device: info?.deviceDescription || '',
      description: info?.requestReason,
      location: parsedNewData?.location || info?.location || '',
      userId: profile.userId,
      requestTypeId: 2,
      eventAttendanceId: info.requestTypeName === 'EDIT_EVENT_LOG' ? info.id : info.id,
      // eventAttendanceId: info.id,
      shiftIdOld: parsedNewData.shiftId,
      typeEdit: info.requestTypeName,
      requestId: info.id,
      eventLogId: parsedOldData?.id,
   };

   const buildAttendanceDateTimeUTC = (date, time) => {
      if (!date || !time) return null;

      const local = dayjs(
         `${format(date, "yyyy-MM-dd")} ${time}`,
         "YYYY-MM-DD HH:mm:ss"
      ).tz(browserTZ);

      return local.utc().format("YYYY-MM-DDTHH:mm:ss[Z]");
   };

   const buildOldData = (parsedOldData, eventLogId) => {
      if (!parsedOldData) return null;

      return {
         attendanceDateTime:
            parsedOldData.attendanceDateTime ||
            parsedOldData.timeCheckIn ||
            parsedOldData.timeCheckOut ||
            null,

         eventTypeId: parsedOldData.eventTypeId,
         shiftId: parsedOldData.shiftId,
         timeZone: parsedOldData.timeZone,
         userId: parsedOldData.userId,
         eventLogId,
      };
   };

   const handleSubmitEditEventLogRequest = async () => {

      const attendanceDateTime = buildAttendanceDateTimeUTC(
         formData.selectDate,
         formData.selectTime,
      );

      const oldDataPayload = JSON.stringify(
         buildOldData(parsedOldDataObj, formData.eventLogId)
      );

      const payload = {
         requestId: formData.requestId,
         typeEdit: info?.oldData
            ? "EDIT_EVENT_LOG"
            : "ADD_EVENT_LOG",

         eventAttendanceId: formData.eventAttendanceId,
         eventTypeId: formData.eventType,
         attendanceDateTime,

         timeZone: browserTZ,

         shiftId: formData.shift,
         remark: formData.description,

         userId: formData.userId,
         requestReason: formData.description,
         langId: localStorage.getItem('i18nextLngId'),
         oldData: oldDataPayload,
         eventLogId: formData.eventLogId,
      };


      setIsSubmitting(true);
      try {
         const response = await editRequest(payload);
         if (response?.data?.responseCode === 0) {
            handleCloseDialog();
            toast.success(t('common.edit-request-successfully'));
            onRefresh();
         } else {
            toast.error(response?.data?.message);
         }
      } catch (error) {
         if (error.response) {
            if (error.response.status !== 401) {
               toast.error(t(error?.response.data));
            }
         } else {
            toast.error(t('common.network-timeout'));
         }
      } finally {
         setIsSubmitting(false);
      }
   };




   const [formData, setFormData] = useState(initialFormData);

   const handleDateTimeChange = (newDateTime) => {
      const d = dayjs(newDateTime);
      setFormData((prev) => ({
         ...prev,
         selectDate: d.toDate(),
         selectTime: d.format('HH:mm:ss'),
      }));
   };

   const handleDataChange = (name, newData) => {
      setFormData((prevData) => ({
         ...prevData,
         [name]: newData,
      }));
   };

   const [useDifferentShiftDate, setUseDifferentShiftDate] = useState(false);

   const handleCheckedChange = (event) => {
      setUseDifferentShiftDate(event.target.checked);
   };

   // useEffect(() => {
   //    if(info?.shiftDate){
   //       setUseDifferentShiftDate(true)
   //    } else {
   //       setUseDifferentShiftDate(false)
   //    }

   // }, [info?.shiftDate]);


   // const userData = UserData();
   // const shiftsData = ShiftData();
   const timezoneData = TimezoneData();
   const sortedShifts = [...shiftsData1].sort((a, b) => b.shiftId - a.shiftId);

   useEffect(() => {
      if (!parsedNewData) return;

      const { date, time } = parseBusinessDateTime(parsedNewData);

      setFormData(prev => ({
         ...prev,
         selectDate: date,
         selectTime: time,
         eventType: parsedNewData.eventTypeId,
         shift: parsedNewData.shiftId,
      }));
   }, [parsedNewData]);

   useEffect(() => {
      if (!formData.userId || !formData.selectDate || !formData.selectTime) return;

      const fetchShift = async () => {
         try {
            setLoadingCount((prev) => prev + 1);

            const dateTimeUTC = buildAttendanceDateTimeUTC(
               formData.selectDate,
               formData.selectTime
            );

            const payload = {
               userId: formData.userId,        // ✅ user đang chọn
               dateTime: dateTimeUTC,          // ✅ ISO8601 UTC (+0)
               langId: localStorage.getItem("i18nextLngId"),
            };

            const response = await getShiftByUser(payload);
            setShiftsData(response.data.data || []);
         } catch (error) {
            toast.error(t(error?.response?.data));
         } finally {
            setLoadingCount((prev) => Math.max(prev - 1, 0));
         }
      };

      fetchShift();
   }, [
      formData.userId,
      formData.selectDate,
      formData.selectTime
   ]);



   return (
      <CustomDialog open transitionDuration={300} maxWidth={'xl'} loading={isDialogLoading} onClose={handleCloseDialog} keepMounted>
         <DialogTitle>
            <div className='flex justify-between'>
               <div className='flex items-center gap-4'>
                  <p className='text-xl font-semibold '>{t('common.edit-request')}</p>
               </div>
               <GrayIconButton onClick={handleCloseDialog} disabled={isDialogLoading}>
                  <CloseIcon />
               </GrayIconButton>
            </div>
         </DialogTitle>
         <DialogContent>
            {info.oldData ? (
               <div className='grid grid-cols-12 gap-y-3 pt-3'>
                  <div className='col-span-12 space-y-3'>
                     <label>{t('common.event-type')}<span className='text-[#EF4444] ml-1'>*</span></label>
                     <div className='flex items-center gap-4'>
                        <div className='flex-1 min-w-0'>
                           <span
                              className={`font-semibold uppercase ${oldEventTypeId === 2 ? 'text-[#3B82F6]' : 'text-[#22C55E]'}`}
                           >
                              {oldEventTypeId === 2
                                 ? t('attendance.CHECK_OUT')
                                 : t('attendance.CHECK_IN')}
                           </span>
                        </div>
                        <ArrowForwardIcon className='text-[#1F2937] shrink-0' fontSize='small' />
                        <div className='flex-1 min-w-0'>
                           <FormControl
                              component='fieldset'
                              sx={{
                                 '.MuiFormGroup-root.MuiFormGroup-row': {
                                    gap: '20px',
                                 },
                              }}
                           >
                              <RadioGroup row aria-label='Event type' name='eventType' value={formData.eventType} onChange={handleInputChange}>
                                 <FormControlLabel value={1} control={<Radio size='small' />} label={t('attendance.CHECK_IN')} />
                                 <FormControlLabel value={2} control={<Radio size='small' />} label={t('attendance.CHECK_OUT')} />
                              </RadioGroup>
                           </FormControl>
                        </div>
                     </div>
                  </div>

                  <div className='col-span-12 space-y-3'>
                     <label>{t('common.date-time')}<span className='text-[#EF4444] ml-1'>*</span></label>
                     <div className='flex items-center gap-4'>
                        <div className='flex-1 min-w-0'>
                           <CustomDateTimePicker
                              mode="singleTime"
                              disabled
                              value={toDateTimeValue(formData.selectDateOld, formData.selectTimeOld)}
                              dateTimeFormat={dateTimeFormat}
                           />
                        </div>
                        <ArrowForwardIcon className='text-[#1F2937] shrink-0' fontSize='small' />
                        <div className='flex-1 min-w-0'>
                           <CustomDateTimePicker
                              mode="singleTime"
                              value={toDateTimeValue(formData.selectDate, formData.selectTime)}
                              dateTimeFormat={dateTimeFormat}
                              onChange={handleDateTimeChange}
                           />
                        </div>
                     </div>
                  </div>

                  <div className='col-span-12 space-y-3'>
                     <label>{t('common.shift')}<span className='text-[#EF4444] ml-1'>*</span></label>
                     <div className='flex items-center gap-4'>
                        <div className='flex-1 min-w-0'>
                           <CustomInput
                              inputType='text'
                              readOnly={true}
                              value={shiftOldName}
                              labelEnable={false}
                           />
                        </div>
                        <ArrowForwardIcon className='text-[#1F2937] shrink-0' fontSize='small' />
                        <div className='flex-1 min-w-0'>
                           <CustomSelect
                              name='shift'
                              value={formData.shift}
                              onChange={handleInputChange}
                              options={sortedShifts}
                              dataType='shift'
                           />
                        </div>
                     </div>
                  </div>

                  {/* <div className='col-span-12 space-y-3'>
                     <label>{t('common.location')}</label>
                     <div className='flex items-center gap-4'>
                        <div className='flex-1 min-w-0'>
                           <CustomInput
                              inputType='text'
                              readOnly={true}
                              value={locationOld}
                              labelEnable={false}
                           />
                        </div>
                        <ArrowForwardIcon className='text-[#1F2937] shrink-0' fontSize='small' />
                        <div className='flex-1 min-w-0'>
                           <CustomInput
                              inputType='text'
                              readOnly={true}
                              value={locationNew}
                              labelEnable={false}
                           />
                        </div>
                     </div>
                  </div> */}

                  <div className='col-span-12 space-y-3'>
                     <label>{t('common.reason')}<span className='text-[#EF4444] ml-1'>*</span></label>
                     <CustomInput
                        name='description'
                        inputType='text'
                        value={formData.description}
                        handleInputChange={handleInputChange}
                        labelEnable={false}
                        placeholder={t('common.reason')}
                     />
                     <div
                        className={`flex justify-end text-xs ${formData.description?.length >= MAX_DESCRIPTION_LENGTH
                           ? 'text-red-500'
                           : 'text-gray-500'
                           }`}
                     >
                        {(formData.description?.length || 0)}/{MAX_DESCRIPTION_LENGTH}
                     </div>
                  </div>
               </div>
            ) : (
               <div className='pt-3 space-y-3'>
                  <div className='space-y-3'>
                     <p>{t('common.event-type')}</p>
                     <FormControl
                        component='fieldset'
                        sx={{
                           '.MuiFormGroup-root.MuiFormGroup-row': {
                              gap: '20px',
                           },
                        }}
                     >
                        <RadioGroup row aria-label='Event type' name='eventType' value={formData.eventType} onChange={handleInputChange}>
                           <FormControlLabel value={1} control={<Radio size='small' />} label={t('attendance.CHECK_IN')} />
                           <FormControlLabel value={2} control={<Radio size='small' />} label={t('attendance.CHECK_OUT')} />
                        </RadioGroup>
                     </FormControl>
                  </div>

                  <div className='grid grid-cols-12 md:gap-x-3 gap-y-3'>
                     <div className='col-span-12 md:col-span-6 space-y-3'>
                        <label>{t('common.userName')}</label>
                        <CustomInput
                           name='username'
                           inputType='text'
                           readOnly={true}
                           value={formData.username}
                           handleInputChange={handleInputChange}
                           labelEnable={false}
                           placeholder={t('common.userName')}
                        />
                     </div>

                     <div className='col-span-12 md:col-span-6 space-y-3'>
                        <label>{t('common.date-time')}<span className='text-[#EF4444] ml-1'>*</span></label>
                        <CustomDateTimePicker
                           mode="singleTime"
                           value={toDateTimeValue(formData.selectDate, formData.selectTime)}
                           dateTimeFormat={dateTimeFormat}
                           onChange={handleDateTimeChange}
                        />
                     </div>

                     <div className='col-span-12 md:col-span-12` space-y-3'>
                        <label>{t('common.shift')}<span className='text-[#EF4444] ml-1'>*</span></label>
                        <CustomSelect
                           name='shift'
                           value={formData.shift}
                           onChange={handleInputChange}
                           options={sortedShifts}
                           dataType='shift'
                        />
                     </div>

                     {/* <div className='col-span-12 md:col-span-6 space-y-3'>
                        <label className='text-[#171717]'>{t('common.location')}</label>
                        <CustomInput
                           inputType='text'
                           readOnly={true}
                           value={formData.location}
                           labelEnable={false}
                        />
                     </div> */}

                     <div className='col-span-12 space-y-3'>
                        <label>{t('common.reason')}<span className='text-[#EF4444] ml-1'>*</span></label>
                        <CustomInput
                           name='description'
                           inputType='text'
                           value={formData.description}
                           handleInputChange={handleInputChange}
                           labelEnable={false}
                           placeholder={t('common.reason')}
                        />
                        <div
                           className={`flex justify-end text-xs ${formData.description?.length >= MAX_DESCRIPTION_LENGTH
                              ? 'text-red-500'
                              : 'text-gray-500'
                              }`}
                        >
                           {(formData.description?.length || 0)}/{MAX_DESCRIPTION_LENGTH}
                        </div>
                     </div>
                  </div>
               </div>
            )}
         </DialogContent>
         <DialogActions>
            <div className='flex gap-2 px-4 py-4'>
               <ControlpanelSecondaryButton onClick={handleCloseDialog} disabled={isDialogLoading}>
                  <p>{t('button.close')}</p>
               </ControlpanelSecondaryButton>
               <ControlpanelPrimaryButton
                  onClick={() => {
                     handleSubmitEditEventLogRequest();
                  }}
                  disabled={isDialogLoading || !formData.description?.trim()}
                  sx={{
                     borderRadius: '10px',
                     textDecoration: 'none'
                  }}
               >
                  <p>{t('button.update')}</p>
               </ControlpanelPrimaryButton>
            </div>
         </DialogActions>
      </CustomDialog>
   );
};

export default EditRequestDialogByUser;
